import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const PlotSales = () => {
  const features = [
    {
      icon: '🏆',
      title: 'Prime Locations',
      description: 'Excellent connectivity and infrastructure'
    },
    {
      icon: '✅',
      title: 'HMDA & RERA Approved',
      description: 'Legal compliance and investment security'
    },
    {
      icon: '🏦',
      title: 'Bank Loans Available',
      description: 'Easy financing options facilitated'
    },
    {
      icon: '📋',
      title: 'Transparent Process',
      description: 'Clear pricing and documentation'
    }
  ];

  const locations = [
    { name: 'Shadnagar', icon: '📍' },
    { name: 'Shankarpally', icon: '📍' },
    { name: 'Sadashivpet', icon: '📍' },
    { name: 'More Locations', icon: '🗺️' }
  ];

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', 
      minHeight: '100vh',
      paddingTop: '60px',
      paddingBottom: '80px'
    }}>
      <Container>
        {/* Hero Section */}
        <div className="text-center mb-5">
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #2180CE 0%, #1a6bb8 100%)',
            padding: '12px 30px',
            borderRadius: '50px',
            marginBottom: '20px',
            boxShadow: '0 4px 15px rgba(33, 128, 206, 0.3)'
          }}>
            <span style={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>
              🏡 PREMIUM PLOT SALES
            </span>
          </div>
          
          <h1 style={{
            color: '#2180CE',
            fontWeight: 800,
            fontSize: '3.5rem',
            marginBottom: '1.5rem',
            lineHeight: '1.2',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}>
            Invest in Your Future
          </h1>
          
          <p style={{
            fontSize: '1.3rem',
            color: '#495057',
            maxWidth: '800px',
            margin: '0 auto',
            lineHeight: '1.8'
          }}>
            Discover prime open plots across Hyderabad's most sought-after locations. 
            HMDA & RERA approved with seamless bank loan assistance.
          </p>
        </div>

        {/* Features Grid */}
        <Row className="g-4 mb-5">
          {features.map((feature, index) => (
            <Col lg={3} md={6} key={index}>
              <Card style={{
                border: 'none',
                borderRadius: '20px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
                height: '100%',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(33, 128, 206, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.08)';
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #2180CE 0%, #1a6bb8 100%)',
                  height: '5px',
                  width: '100%'
                }} />
                <Card.Body className="text-center p-4">
                  <div style={{
                    fontSize: '3.5rem',
                    marginBottom: '1rem'
                  }}>
                    {feature.icon}
                  </div>
                  <h4 style={{
                    color: '#2180CE',
                    fontWeight: 700,
                    marginBottom: '0.8rem',
                    fontSize: '1.2rem'
                  }}>
                    {feature.title}
                  </h4>
                  <p style={{
                    color: '#6c757d',
                    marginBottom: 0,
                    fontSize: '0.95rem',
                    lineHeight: '1.6'
                  }}>
                    {feature.description}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Locations Section */}
        <Card style={{
          border: 'none',
          borderRadius: '25px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          overflow: 'hidden',
          marginBottom: '3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #FFBE1D 0%, #f0b000 100%)',
            padding: '40px',
            textAlign: 'center'
          }}>
            <h2 style={{
              color: '#333',
              fontWeight: 800,
              fontSize: '2.5rem',
              marginBottom: '0.5rem'
            }}>
              Available Locations
            </h2>
            <p style={{
              color: '#555',
              fontSize: '1.1rem',
              marginBottom: 0
            }}>
              Strategic locations across Hyderabad
            </p>
          </div>
          
          <Card.Body style={{ padding: '50px 40px' }}>
            <Row className="g-4">
              {locations.map((location, index) => (
                <Col md={3} sm={6} key={index}>
                  <div style={{
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                    padding: '30px 20px',
                    borderRadius: '15px',
                    textAlign: 'center',
                    border: '2px solid #e9ecef',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#2180CE';
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(33, 128, 206, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e9ecef';
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>
                      {location.icon}
                    </div>
                    <h5 style={{
                      color: '#2180CE',
                      fontWeight: 700,
                      marginBottom: 0,
                      fontSize: '1.1rem'
                    }}>
                      {location.name}
                    </h5>
                  </div>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>

        {/* Call to Action */}
        <Card style={{
          border: 'none',
          borderRadius: '25px',
          background: 'linear-gradient(135deg, #2180CE 0%, #1a6bb8 100%)',
          color: 'white',
          boxShadow: '0 15px 50px rgba(33, 128, 206, 0.3)'
        }}>
          <Card.Body className="text-center" style={{ padding: '60px 40px' }}>
            <h2 style={{
              fontWeight: 800,
              fontSize: '2.5rem',
              marginBottom: '1rem'
            }}>
              Ready to Invest in Your Dream Plot?
            </h2>
            <p style={{
              fontSize: '1.2rem',
              marginBottom: '2rem',
              opacity: 0.95
            }}>
              Get in touch with our expert team today for personalized assistance
            </p>
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="/contact" style={{
                background: '#FFBE1D',
                color: '#333',
                padding: '18px 40px',
                borderRadius: '12px',
                fontWeight: 700,
                fontSize: '1.1rem',
                textDecoration: 'none',
                display: 'inline-block',
                boxShadow: '0 6px 20px rgba(255, 190, 29, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 8px 25px rgba(255, 190, 29, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(255, 190, 29, 0.4)';
              }}>
                📞 Contact Us Now
              </a>
              <a href="tel:+919876543210" style={{
                background: 'rgba(255,255,255,0.15)',
                color: 'white',
                padding: '18px 40px',
                borderRadius: '12px',
                fontWeight: 700,
                fontSize: '1.1rem',
                textDecoration: 'none',
                display: 'inline-block',
                border: '2px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.25)';
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.15)';
                e.target.style.transform = 'translateY(0)';
              }}>
                📱 Call Now
              </a>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default PlotSales;